import type { PathInspectorNodePackets } from 'components/DeviceView/deviceViewTypes';

export const hasPathInspectorPackets = (
  pathInspectorPackets: PathInspectorNodePackets,
): boolean =>
  Object.keys(pathInspectorPackets.edgePackets ?? {}).length > 0 ||
  Object.keys(pathInspectorPackets.acceptedPackets ?? {}).length > 0 ||
  Object.keys(pathInspectorPackets.droppedPackets ?? {}).length > 0 ||
  Object.keys(pathInspectorPackets.generatedPackets ?? {}).length > 0;
